export default __webpack_public_path__ + "media/images/van-46ca64ac77a0454d0cc5add26561c1e3.jpg";